module.exports = __webpack_public_path__ + "static/media/cliffHousePatch01.db2752ec.jpeg";